import React from 'react';
import { Box, Modal } from '@mantine/core';
import { useModalContainer } from '../../../contexts/ModalContainerContext';
import { useRequestTrackingModal } from '../../../contexts/RequestTrackingModalContext';
import { RequestTrackingPanel } from './RequestTrackingPanel';

/**
 * Global request tracker — opened from the app header or programmatically.
 */
export function RequestTrackingModal() {
  const modalContainer = useModalContainer();
  const { opened, closeRequestTracker, refreshSignal, setActiveRequestCount } =
    useRequestTrackingModal();

  return (
    <Modal
      opened={opened}
      onClose={closeRequestTracker}
      title="Request tracker"
      size="xl"
      centered
      portalProps={modalContainer ? { target: modalContainer } : undefined}
      styles={{
        body: { paddingTop: 8 },
      }}
    >
      <Box
        style={{
          maxHeight: 'min(72vh, 680px)',
          overflow: 'auto',
        }}
      >
        <RequestTrackingPanel
          title=""
          layout="embedded"
          showProjectScope
          pollIntervalMs={10000}
          refreshSignal={refreshSignal}
          onActiveRequestsChange={(_hasActive, activeCount) => {
            setActiveRequestCount(activeCount);
          }}
        />
      </Box>
    </Modal>
  );
}
